import {
  LOGIN_USER,
  CLEAR_USER_DATA,
  USER_CART_SESSION,
  SET_CUSTOMER_DETAILS,
  SET_FIRSTNAME,
  SET_OTP_FLAG,
} from "./types";
import SystemConstant from "constants/SystemConstant";
import API_LIST from "./apiList";
import axios from "api/axiosInstance";
import { setCookie, calculateMaxQty } from "constants/utils";
import { setAlert } from "./appActions";
import { getCartItems, getUserSession } from "./cartActions";
import { getUserInfo } from "./userInfoAction";
import { getMaxOrderQtyPerCategory, getRemainingMaxOrderQty } from "actions/maxOrderQtyAction";

export function loginUser(loginPayLoad, cbSuccess, cbFailure) {
  return (dispatch, getState) => {
    const headers = SystemConstant.adminRequestHeaders;
    const { totalItemsInCart } = getState().cartReducer;
    const normalizedPayLoad = {
      ...loginPayLoad,
      email: (loginPayLoad?.email || "").trim().toLowerCase(),
    };

    axios
      .post(`${API_LIST.userLogin}`, normalizedPayLoad, { headers })
      .then((response) => {
        const data = response.data?.token;

        localStorage.removeItem("maxOrderQty");
        if (typeof data === 'string') {
          if (totalItemsInCart > 0) {
            setCookie(
              "oldGuestCartSession", SystemConstant.cookies.get("cartSession") || SystemConstant.cookies.get("guest_quote_id"));
          }
          setCookie("cartSession", data);
          setCookie("userEmail", normalizedPayLoad.email);
          setCookie("otpPending", "true");
          //dispatch(setUserLoginEmail(loginPayLoad.username)); 

          // cbSuccess(response.data);   
          cbSuccess();
        } else if (Array.isArray(data) && data[0]?.data?.status === 'failed') {
          dispatch(
            setAlert(data[0]?.data?.message || SystemConstant.failedToLoginText, SystemConstant.warning)
          );
          cbFailure();
        } else {
          dispatch(
            setAlert(SystemConstant.failedToLoginText, SystemConstant.warning)
          );
          cbFailure();
        }
      })
      .catch((err) => {
        dispatch(
          setAlert(
            err?.response?.data?.message ||
            SystemConstant.somethingWentWrongText,
            SystemConstant.warning
          )
        );
        cbFailure();
      });
  };
}

export function loginGuestUser(guestPayload, cbSuccess, cbFailure) {
  return (dispatch, getState) => {
    // const headers = SystemConstant.adminRequestHeaders;  
    const headers = SystemConstant.getUserRequestHeaders();
    headers["x-publishable-api-key"] = process.env.REACT_APP_X_PUBLISHER_API_KEY;
    const { totalItemsInCart } = getState().cartReducer;
    const normalizedPayLoad = {
      ...guestPayload,
      email: (guestPayload?.email || "").trim().toLowerCase(),
    };

    axios
      .post(`${API_LIST.userLogin}`, normalizedPayLoad, { headers })
      .then((response) => {
        const data = response.data;

        localStorage.removeItem("maxOrderQty");
        const token = data.token;
        // Case 1: token response is a string (success) 
        console.log("token :>>>> " , token ) ; 
        if (typeof token === 'string') {
          if (totalItemsInCart > 0) {
            setCookie(
              "oldGuestCartSession",
              SystemConstant.cookies.get("cartSession") || SystemConstant.cookies.get("guest_quote_id")
            );
          }
          setCookie("cartSession", token);
          setCookie("otpPending", "true");
          // if (data[0]?.email) {
          //   setCookie("userEmail", data[0].email);
          // } else {
          //   setCookie("userEmail", guestPayload.email || 'guest');
          // }
          setCookie("userEmail", normalizedPayLoad.email || 'guest');

          cbSuccess(token);

          // Case 2: failure with known structure
        } else if (!data) {
          dispatch(
            setAlert(
              `${SystemConstant.somethingWentWrongText}`,
              SystemConstant.warning
            )
          )
          cbFailure();

          // Catch-all failure
        } else {
          dispatch(
            setAlert(
              `${SystemConstant.somethingWentWrongText}`,
              SystemConstant.warning
            )
          )
          cbFailure();
        }
      })
      .catch((err) => {
        console.error("Login API error:", err);
        dispatch(
          setAlert(
            `${SystemConstant.invalidCredentials}` ||
            SystemConstant.somethingWentWrongText,
            SystemConstant.warning
          )
        );
        cbFailure();
      });
  };
}

export function userExistCheck(email, cbSuccess, cbFailure) {
  return (dispatch) => {

    const headers = SystemConstant.getUserRequestHeaders();
    headers['x-publishable-api-key'] = process.env.REACT_APP_X_PUBLISHER_API_KEY;

    const normalizedEmail = (email || "").trim().toLowerCase();
    console.log("headers :>>> " , headers ) ;
    axios.post(API_LIST.userExist, { email: normalizedEmail }, { headers })  
      // Promise.resolve({ data : false})
      .then((response) => {

        const isUserExist = response.data;

        console.log("isUserExist :>>> " , isUserExist) ;
        if (isUserExist) {
          cbSuccess();
        }else { 
          cbFailure();
        }
      })
      .catch((err) => {
        // console.error("Login API error:", err);
        // dispatch(
        //   setAlert(
        //     `${SystemConstant.invalidCredentials}` ||
        //     SystemConstant.somethingWentWrongText,
        //     SystemConstant.warning
        //   )
        // );
        cbFailure();
      });
  }
}
export function createUserCartSession(callback) {
  return (dispatch) => {
    const headers = SystemConstant.getUserRequestHeaders();
    headers['x-publishable-api-key'] = process.env.REACT_APP_X_PUBLISHER_API_KEY;

    axios
      .get(`${API_LIST.createUserCartSession}`, {
        withCredentials: true,
        headers
      })

      // Promise.resolve({ data: 28284 })
      .then((response) => {
        if (response.data) {

          setCookie("userCartToken", response.data);
          dispatch(setUserCartToken(response.data));
          dispatch(getCartItems());
          callback();
        } else {
          dispatch(
            setAlert(
              `${SystemConstant.somethingWentWrongText} ${SystemConstant.cartTokenFailedText}`,
              SystemConstant.warning
            )
          );
        }
      })
      .catch(() =>
        dispatch(
          setAlert(
            `${SystemConstant.somethingWentWrongText} ${SystemConstant.cartTokenFailedText}`,
            SystemConstant.warning
          )
        )
      );
  };
}

export function getCustomerDetails(cb) {
  return async (dispatch) => {
    const headers = SystemConstant.getUserRequestHeaders();
    headers['x-publishable-api-key'] = process.env.REACT_APP_X_PUBLISHER_API_KEY;
    axios
      .get(`${API_LIST.getCustomerDetails}`, { headers })
      .then(async (response) => {
        if (response.data) {

          // const access_code = response.data["custom_attributes"].find(
          //   (x) => x["attribute_code"] === "access_id"
          // ).value; 
          // const company_code = response.data["custom_attributes"].find(
          //   (x) => x["attribute_code"] === "company_code"
          // ).value; 

          const { access_id, country_id, company_code: companyCode } = response.data?.customer?.metadata || {};
          const access_code = access_id || "6";
          const company_code = companyCode || "1140";
          const cust_id = response.data.customer["id"];

          // Prefer address country for storefront currency (addresses are source of truth).
          // Metadata alone was causing AED when country_id was missing/wrong (e.g. AE default).
          const addresses = Array.isArray(response.data?.customer?.addresses)
            ? response.data.customer.addresses
            : [];
          const defaultBilling = addresses.find((add) => add?.default_billing === true);
          const defaultShipping = addresses.find((add) => add?.default_shipping === true);
          const anyAddressWithCountry = addresses.find(
            (add) => typeof add?.country_id === "string" && add.country_id.trim()
          );
          const addressCountry =
            (defaultShipping?.country_id ||
              defaultBilling?.country_id ||
              anyAddressWithCountry?.country_id ||
              "")
              .toString()
              .trim()
              .toUpperCase();
          const metadataCountry =
            typeof country_id === "string" ? country_id.trim().toUpperCase() : "";
          const country_code =
            addressCountry ||
            metadataCountry ||
            SystemConstant.defaultCountryId;

          setCookie("access_code", access_code);
          setCookie("company_code", company_code);
          setCookie("cust_id", cust_id);
          setCookie("country_code", country_code);
          if (cb) {
            cb(response.data.customer);
          }
          dispatch(setUserDetails(response.data));
          dispatch(getUserInfo(country_code));


          // set the user cart info if any 


          // commented below code because there is no use of it , ask if there should be merge cart functionality  

          // const userSession = getUserSession();
          // const cartItems = await getCartItemsForLoggedInUserToCreateLookUp(
          //   userSession
          // );
          // if (cartItems && cartItems.length > 0) {
          //   cartItems.map((cartItem) => {
          //     setLookUpTablePerCategoryInCart(
          //       cust_id,
          //       cartItem["extension_attributes"]["product_category"],
          //       cartItem
          //     );
          //   });
          // }
        } else {
          dispatch(
            setAlert(
              `${SystemConstant.somethingWentWrongText} ${SystemConstant.customerDetailsFailedText}`,
              SystemConstant.warning
            )
          );
        }
      })
      .catch(() =>
        dispatch(
          setAlert(
            `${SystemConstant.somethingWentWrongText} ${SystemConstant.customerDetailsFailedText}`,
            SystemConstant.warning
          )
        )
      );
  };
}

export function mergeGuestAndUserCart(customerId, cb) {
  return (dispatch) => {
    const domainVerify = SystemConstant.cookies.get('domainVerify');
    let newSession = SystemConstant.cookies.get('newSession');
    let headers;
    if (domainVerify === 'true' && newSession !== "") {
      headers = { ...newSession };
    } else {
      headers = SystemConstant.getUserRequestHeaders(); 
    } 

    headers['x-publishable-api-key'] = process.env.REACT_APP_X_PUBLISHER_API_KEY ; 
    const quoteId = SystemConstant.getCookieValue("cart_id") ; 

    if (!quoteId) {
      cb();
      return;
    }

    const payload = { quoteId : quoteId } ;
    axios
      .post(
        `${API_LIST.mergeGuestUserCart}`,
         payload,
        { headers }
      )
      .then((response) => {
        if (response.data?.success) {
          if (response.data.quote_id) {
            setCookie("userCartToken", response.data.quote_id);
          }
          SystemConstant.cookies.remove("oldGuestCartSession");
          SystemConstant.cookies.remove("cart_id");
          SystemConstant.cookies.remove("guest_quote_id");
        } else {
          dispatch(
            setAlert(
              `${SystemConstant.somethingWentWrongText} ${SystemConstant.guestUserCartMergeFailedText}`,
              SystemConstant.warning
            )
          );
        }
        cb();
      })
      .catch(() => {
        dispatch(
          setAlert(
            `${SystemConstant.somethingWentWrongText} ${SystemConstant.guestUserCartMergeFailedText}`,
            SystemConstant.warning
          )
        );
        cb();
      });
  };
}

async function getCartItemsForLoggedInUserToCreateLookUp(cartSession) {
  const userEmail = SystemConstant.cookies.get("userEmail");
  let getCartURL, headers;
  if (!userEmail) {
    // guest user
    let cartSessionTemp = cartSession;
    headers = SystemConstant.adminRequestHeaders;
    getCartURL = `${API_LIST.session}${cartSessionTemp}/${API_LIST.cartItems}`;
  } else {
    // logged in user
    headers = SystemConstant.getUserRequestHeaders();
    getCartURL = `${API_LIST.userCartItems}`;
    try {
      await axios.post(`${API_LIST.createUserCartSession}`, null, { headers });
    } catch (e) {
      // Ignore if cart already exists
      if (e.response?.status !== 400) {
        console.error("Failed to create cart", e);
      }
    }
  }

  return new Promise((resolve, reject) => {
    axios
      .get(getCartURL, { headers })
      .then((response) => {
        if (response.data) {
          resolve(response.data);
        } else {
          reject("error in gettting cart items");
        }
      })
      .catch(() => reject("error in gettting cart items"));
  });
}

const setLookUpTablePerCategoryInCart = async (
  cust_id,
  categoryId,
  cartItem
) => {
  const maxOrderQtyPerCategory = await getMaxOrderQtyPerCategory(
    cust_id,
    categoryId
  );
  const remaining = getRemainingMaxOrderQty(maxOrderQtyPerCategory);
  const createCartObj = {
    categoryId: categoryId,
    maxOderQty: remaining ?? 0,
    cust_id: cust_id,
    buyQty: +cartItem["qty"],
    sku: cartItem["sku"],
    action: "ADD",
  };
  if (remaining !== null) calculateMaxQty(categoryId, createCartObj);
};

export function clearUserData() {
  return {
    type: CLEAR_USER_DATA,
  };
}

export function setUserLoginEmail(userEmail) {
  return {
    type: LOGIN_USER,
    payload: userEmail,
  };
}

export function setUserCartToken(cartToken) {
  return {
    type: USER_CART_SESSION,
    payload: cartToken,
  };
}

export function setUserDetails(userDetails) {
  return {
    type: SET_CUSTOMER_DETAILS,
    payload: userDetails,
  };
}

export function setFirstname(payload) {
  return {
    type: SET_FIRSTNAME,
    payload,
  };
}

export function setOtpFlag(payload) {
  return {
    type: SET_OTP_FLAG,
    payload,
  }
}